import React from "react";

interface SearchResultsInfoProps {
  page: number;
  limit: number;
  total: number;
  entityName: string; // 'exercises', 'programs', 'users' ...
  isSearchMode?: boolean;
}

const SearchResultsInfo: React.FC<SearchResultsInfoProps> = ({
  page,
  limit,
  total,
  entityName,
  isSearchMode = false,
}) => {
  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);

  return (
    <p className="text-sm text-gray-700 dark:text-gray-300">
      Showing <span className="font-medium">{startItem}</span> to{" "}
      <span className="font-medium">{endItem}</span> of{" "}
      <span className="font-medium">{total}</span> {entityName}
      {isSearchMode ? " (search results)" : ""}
    </p>
  );
};

export default SearchResultsInfo;
